import * as i0 from '@angular/core';
import { EventEmitter, Output, Input, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/material/progress-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import { AzavistaSharedModule } from '@azavista/components/shared';
import * as i6 from '@azavista/components/button';
import { AzavistaButtonModule } from '@azavista/components/button';
import * as i4 from '@angular/common';
import * as i5 from '@ngx-translate/core';
function AzavistaJobsStatusComponent_div_1_mat_progress_bar_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-progress-bar", 13);
  }
  if (rf & 2) {
    const jobInfo_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("value", jobInfo_r2.totals.completedPercentage);
  }
}
function AzavistaJobsStatusComponent_div_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const jobInfo_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", jobInfo_r2.totals.completedPercentage, "%");
  }
}
function AzavistaJobsStatusComponent_div_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "span", 15);
    i0.ɵɵtext(2, "NO_ITEMS_TO_PROCESS");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaJobsStatusComponent_div_1_azavista_flat_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 16);
    i0.ɵɵlistener("click", function AzavistaJobsStatusComponent_div_1_azavista_flat_button_7_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const jobInfo_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onJobCancelled(jobInfo_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, "CANCEL"), " ");
  }
}
function AzavistaJobsStatusComponent_div_1_azavista_flat_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 17);
    i0.ɵɵlistener("click", function AzavistaJobsStatusComponent_div_1_azavista_flat_button_8_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const jobInfo_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onJobErrorRequested(jobInfo_r2));
    });
    i0.ɵɵelementStart(1, "mat-icon");
    i0.ɵɵtext(2, "error");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 15);
    i0.ɵɵtext(4, "ERROR");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaJobsStatusComponent_div_1_azavista_flat_button_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "azavista-flat-button", 18)(1, "span", 15);
    i0.ɵɵtext(2, "COMPLETED");
    i0.ɵɵelementEnd()();
  }
}
function AzavistaJobsStatusComponent_div_1_ng_container_10_ng_container_1_azavista_flat_button_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 22);
    i0.ɵɵlistener("click", function AzavistaJobsStatusComponent_div_1_ng_container_10_ng_container_1_azavista_flat_button_1_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const jobInfo_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onJobCompletedCustomActionClicked(jobInfo_r2, action_r7));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const action_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(action_r7.label);
  }
}
function AzavistaJobsStatusComponent_div_1_ng_container_10_ng_container_1_a_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 23);
    i0.ɵɵlistener("click", function AzavistaJobsStatusComponent_div_1_ng_container_10_ng_container_1_a_2_Template_a_click_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const action_r7 = i0.ɵɵnextContext().$implicit;
      const jobInfo_r2 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onJobCompletedCustomActionClicked(jobInfo_r2, action_r7, $event));
    });
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const action_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", action_r7.href, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(action_r7.label);
  }
}
function AzavistaJobsStatusComponent_div_1_ng_container_10_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaJobsStatusComponent_div_1_ng_container_10_ng_container_1_azavista_flat_button_1_Template, 3, 1, "azavista-flat-button", 20)(2, AzavistaJobsStatusComponent_div_1_ng_container_10_ng_container_1_a_2_Template, 3, 2, "a", 21);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const action_r7 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !action_r7.href);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", action_r7.href);
  }
}
function AzavistaJobsStatusComponent_div_1_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, AzavistaJobsStatusComponent_div_1_ng_container_10_ng_container_1_Template, 3, 2, "ng-container", 19);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const jobInfo_r2 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", jobInfo_r2.completedCustomActions);
  }
}
function AzavistaJobsStatusComponent_div_1_azavista_flat_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "azavista-flat-button", 24);
    i0.ɵɵlistener("click", function AzavistaJobsStatusComponent_div_1_azavista_flat_button_12_Template_azavista_flat_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const jobInfo_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onJobResultsDownloaded(jobInfo_r2));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(2, 1, "DOWNLOAD"), " ");
  }
}
function AzavistaJobsStatusComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, AzavistaJobsStatusComponent_div_1_mat_progress_bar_3_Template, 1, 1, "mat-progress-bar", 4)(4, AzavistaJobsStatusComponent_div_1_div_4_Template, 2, 1, "div", 5)(5, AzavistaJobsStatusComponent_div_1_div_5_Template, 3, 0, "div", 6);
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtemplate(7, AzavistaJobsStatusComponent_div_1_azavista_flat_button_7_Template, 3, 3, "azavista-flat-button", 7)(8, AzavistaJobsStatusComponent_div_1_azavista_flat_button_8_Template, 5, 0, "azavista-flat-button", 8)(9, AzavistaJobsStatusComponent_div_1_azavista_flat_button_9_Template, 3, 0, "azavista-flat-button", 9)(10, AzavistaJobsStatusComponent_div_1_ng_container_10_Template, 2, 1, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div");
    i0.ɵɵtemplate(12, AzavistaJobsStatusComponent_div_1_azavista_flat_button_12_Template, 3, 3, "azavista-flat-button", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 11)(14, "button", 12);
    i0.ɵɵlistener("click", function AzavistaJobsStatusComponent_div_1_Template_button_click_14_listener() {
      const jobInfo_r2 = i0.ɵɵrestoreView(_r1).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.onRemoveJob(jobInfo_r2));
    });
    i0.ɵɵelementStart(15, "mat-icon");
    i0.ɵɵtext(16, "clear");
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const jobInfo_r2 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(jobInfo_r2.job.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.hasCount(jobInfo_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.hasCount(jobInfo_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r3.hasCount(jobInfo_r2));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !jobInfo_r2.hideCancelButton && ctx_r3.canCancelJob(jobInfo_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.isInErrorState(jobInfo_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r3.isCompleted(jobInfo_r2));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", jobInfo_r2.completedCustomActions && ctx_r3.isCompleted(jobInfo_r2));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r3.canDownloadJobResults(jobInfo_r2));
  }
}
let AzavistaJobsStatusComponent = /*#__PURE__*/(() => {
  class AzavistaJobsStatusComponent {
    constructor() {
      this.jobCancelled = new EventEmitter();
      this.jobErrorRequested = new EventEmitter();
      this.jobResultsDownloaded = new EventEmitter();
      this.jobRemoved = new EventEmitter();
      this.completedCustomActionClicked = new EventEmitter();
    }
    canCancelJob(jobInfo) {
      const jobStatus = jobInfo.job.status;
      return jobStatus !== "completed" /* JobStatus.completed */ && jobStatus !== "cancelled" /* JobStatus.cancelled */ && jobStatus !== "error" /* JobStatus.error */;
    }
    isInErrorState(jobInfo) {
      return jobInfo.job.status === "error" /* JobStatus.error */;
    }
    isCompleted(jobInfo) {
      return jobInfo.job.status === "completed" /* JobStatus.completed */;
    }
    hasCount(jobInfo) {
      return jobInfo.totals.totalCount > 0;
    }
    canDownloadJobResults(jobInfo) {
      return jobInfo.job.category === "export" /* JobCategory.export */ && jobInfo.job.status === "completed" /* JobStatus.completed */;
    }
    onJobCompletedCustomActionClicked(jobInfo, action, ev) {
      if (ev) {
        ev.preventDefault();
      }
      this.completedCustomActionClicked.next({
        jobInfo: jobInfo,
        action: action
      });
    }
    onJobCancelled(jobInfo) {
      this.jobCancelled.emit(jobInfo);
    }
    onJobErrorRequested(jobInfo) {
      this.jobErrorRequested.emit(jobInfo);
    }
    onJobResultsDownloaded(jobInfo) {
      this.jobResultsDownloaded.emit(jobInfo);
    }
    onRemoveJob(jobInfo) {
      this.jobRemoved.emit(jobInfo);
    }
    static {
      this.ɵfac = function AzavistaJobsStatusComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaJobsStatusComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AzavistaJobsStatusComponent,
        selectors: [["azavista-jobs-status"]],
        inputs: {
          data: "data"
        },
        outputs: {
          jobCancelled: "jobCancelled",
          jobErrorRequested: "jobErrorRequested",
          jobResultsDownloaded: "jobResultsDownloaded",
          jobRemoved: "jobRemoved",
          completedCustomActionClicked: "completedCustomActionClicked"
        },
        standalone: false,
        decls: 2,
        vars: 1,
        consts: [[1, "jobs-container", "azavista-jobs-status-component", "aza-cmp-flex-column"], ["class", "job aza-cmp-flex-row mat-elevation-z2", 4, "ngFor", "ngForOf"], [1, "job", "aza-cmp-flex-row", "mat-elevation-z2"], [1, "label", "aza-cmp-wrap"], ["class", "progress", 3, "value", 4, "ngIf"], ["class", "percentage", 4, "ngIf"], [4, "ngIf"], ["class", "cancel-button", 3, "click", 4, "ngIf"], ["color", "warn", "class", "cancel-button", 3, "click", 4, "ngIf"], ["color", "primary", "disabled", "", 4, "ngIf"], ["class", "download-button", 3, "click", 4, "ngIf"], [1, "remove-job", "aza-cmp-flex-row", "aza-cmp-flex-item-grow", "aza-cmp-flex-item-content-end"], ["mat-icon-button", "", 3, "click"], [1, "progress", 3, "value"], [1, "percentage"], ["translate", ""], [1, "cancel-button", 3, "click"], ["color", "warn", 1, "cancel-button", 3, "click"], ["color", "primary", "disabled", ""], [4, "ngFor", "ngForOf"], ["class", "job-custom-action job-completed-custom-action", 3, "click", 4, "ngIf"], ["mat-button", "", "class", "job-custom-action job-completed-custom-action", 3, "href", "click", 4, "ngIf"], [1, "job-custom-action", "job-completed-custom-action", 3, "click"], ["mat-button", "", 1, "job-custom-action", "job-completed-custom-action", 3, "click", "href"], [1, "download-button", 3, "click"]],
        template: function AzavistaJobsStatusComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, AzavistaJobsStatusComponent_div_1_Template, 17, 9, "div", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.data.jobs);
          }
        },
        dependencies: [i1.MatProgressBar, i2.MatAnchor, i2.MatIconButton, i3.MatIcon, i4.NgForOf, i4.NgIf, i5.TranslateDirective, i6.AzavistaFlatButtonComponent, i5.TranslatePipe],
        styles: [".label[_ngcontent-%COMP%]{width:30em}.progress[_ngcontent-%COMP%]{width:300px}.percentage[_ngcontent-%COMP%]{width:30px}.download-button[_ngcontent-%COMP%]{width:100px}"]
      });
    }
  }
  return AzavistaJobsStatusComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AzavistaJobsStatusModule = /*#__PURE__*/(() => {
  class AzavistaJobsStatusModule {
    static {
      this.ɵfac = function AzavistaJobsStatusModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AzavistaJobsStatusModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: AzavistaJobsStatusModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [MatProgressBarModule, MatButtonModule, MatIconModule, AzavistaSharedModule, AzavistaButtonModule]
      });
    }
  }
  return AzavistaJobsStatusModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO: If we keep this the same as servicelib result, we must have dedicated library containing interfaces, enums etc
//       which can be used from servicelib, components and main app

/**
 * Generated bundle index. Do not edit.
 */

export { AzavistaJobsStatusComponent, AzavistaJobsStatusModule };
